export default {
    data() {
        return {
            errors: {}
        }
    },

    methods: {
        getError(name) {
            return typeof this.errors[name] !== 'undefined' ? this.errors[name][0] : null
        },

        catchValidationErrors(error) {
            if (error.response.status === 422) {
                this.errors = error.response.data.errors
            }
        }
    }
}
